var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "idml-tree modal-body--layers" },
    _vm._l(_vm.displayNodes, function (node, index) {
      return _c(
        "li",
        { key: node.properties.id || index },
        [
          _c(
            "div",
            {
              staticClass: "d-flex align-items-center",
              class: {
                "c-folder-layer__folder": _vm.isFolder(node),
                "layer--item": !_vm.isFolder(node),
              },
            },
            [
              _vm.selectable
                ? _c("b-form-checkbox", {
                    staticClass: "mr-2",
                    attrs: {
                      checked: _vm.isSelected(node),
                      disabled: !_vm.isImportable(node),
                      "aria-label": `Import ${node.name}`,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("toggle", { node, selected: $event })
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isFolder(node)
                ? _c(
                    "button",
                    {
                      staticClass: "idml-tree__toggle",
                      attrs: {
                        type: "button",
                        "aria-expanded": !_vm.collapsed[index],
                        "aria-label": `${
                          _vm.collapsed[index] ? "Expand" : "Collapse"
                        } ${node.name}`,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$set(
                            _vm.collapsed,
                            index,
                            !_vm.collapsed[index]
                          )
                        },
                      },
                    },
                    [
                      _c("b-icon", {
                        class: _vm.collapsed[index] ? "closed" : "opened",
                        attrs: { icon: "triangle-fill" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "idml-tree__node d-flex align-items-center",
                  class: {
                    "idml-tree__node--selected": _vm.selected === node,
                    "text-muted": node.visible === false,
                    "c-folder-layer__item mt-2": !_vm.isFolder(node),
                  },
                  attrs: {
                    type: "button",
                    "aria-pressed": _vm.selected === node,
                    title: node.name || node.properties.kind,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("select", node)
                    },
                  },
                },
                [
                  _vm.isFolder(node)
                    ? _c(
                        "svg",
                        {
                          staticClass: "mr-2 flex-shrink-0",
                          attrs: {
                            width: "20",
                            height: "20",
                            "aria-hidden": "true",
                          },
                        },
                        [
                          _c("use", {
                            attrs: {
                              href: "/img/icons/sprite.svg#file-folder-svg",
                            },
                          }),
                        ]
                      )
                    : _c(
                        "span",
                        { staticClass: "c-folder-layer__item--preview mr-2" },
                        [
                          _c("b-icon", {
                            staticClass: "d-block",
                            attrs: { icon: _vm.icon(node) },
                          }),
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c("span", { staticClass: "layer--item__text" }, [
                    _vm._v(_vm._s(node.name || node.properties.kind)),
                  ]),
                  _vm._v(" "),
                  _vm.selectable &&
                  !_vm.isFolder(node) &&
                  _vm.isSelected(node) &&
                  _vm.fieldTypeOptions(node).length > 1
                    ? _c(
                        "select",
                        {
                          staticClass:
                            "form-control form-control-sm idml-tree__field-type ml-auto",
                          domProps: { value: node.__fieldType },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                            },
                            change: function ($event) {
                              return _vm.$emit("field-type", {
                                node,
                                fieldType: $event.target.value,
                              })
                            },
                          },
                        },
                        _vm._l(_vm.fieldTypeOptions(node), function (option) {
                          return _c(
                            "option",
                            {
                              key: option.value,
                              domProps: { value: option.value },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(option.text) +
                                  "\n          "
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  node.properties.image && node.properties.image.requiresUpload
                    ? _c("span", { staticClass: "badge badge-warning ml-2" }, [
                        _vm._v("Image required"),
                      ])
                    : node.properties.image && !_vm.isImportable(node)
                    ? _c("span", { staticClass: "badge badge-warning ml-2" }, [
                        _vm._v("Unsupported image"),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  node.visible === false
                    ? _c("span", { staticClass: "small ml-2" }, [
                        _vm._v("Hidden"),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          node.children && node.children.length
            ? _c(
                "b-collapse",
                { attrs: { visible: !_vm.collapsed[index] } },
                [
                  _c("IDMLLayersTree", {
                    staticClass: "ml-3 mb-2",
                    attrs: {
                      nodes: node.children,
                      selected: _vm.selected,
                      selectable: _vm.selectable,
                      "selected-ids": _vm.selectedIds,
                    },
                    on: {
                      select: function ($event) {
                        return _vm.$emit("select", $event)
                      },
                      toggle: function ($event) {
                        return _vm.$emit("toggle", $event)
                      },
                      "field-type": function ($event) {
                        return _vm.$emit("field-type", $event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }